<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";
import SuppliersApi from "@/services/suppliers-api";

export default {
  page: {
    title: "Liste des articles",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout},
  data() {
    return {
        imageModalSelectedItem:'',
        itemsFilter: '',
        isItemsTableBusy: false,
        itemsList: [],
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        showImageModal: false,
        imageModalUrl: '',
        endOfFindItems:false,
        selectedImage: null,
        suppliersList:[],
        selected:null,
        selectedSupplier:null,
        selectedSupplierName:null,
    };
  }, 
    mounted(){
    this.findItems(null);
    this.getSuppliers();
  },
    methods: {

    findItems() {
      this.isItemsTableBusy = true;
      ItemsApi.findAll(this.itemsFilter, this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.selectedSupplier==null ? null : this.selectedSupplier.id)
        .then(itemsList => {
          this.itemsList = itemsList.list
          this.pagemodelMain.totalRows = itemsList.total;
          this.pagemodelMain.currentPage = itemsList.page;
          this.pagemodelMain.perPage = itemsList.pageSize;
          this.pagemodelMain.pageSize = itemsList.pageSize;
        })
        .finally(() => {
        this.isItemsTableBusy = false;
        this.endOfFindItems =true;
      })
    },
    getSuppliers(){
      SuppliersApi.getAllSuppliers().then(
        response => {
          this.suppliersList=response;
        }
      )
    },
    },

      watch: {
        selectedSupplier: function() {
            this.findItems()
        },


    }
};
</script>
<template>
  <Layout>
    <div class="row pt-4">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Catalogue <span class="d-none d-sm-inline   ">des Articles</span> de <span :class="this.selectedSupplierName ? 'text-danger' :''"> {{this.selectedSupplierName ? this.selectedSupplierName :'Tous les fournisseurs' }}</span></h2>
            <p class="card-title-desc font-size-14">
              Liste des articles 
            </p>

            <div class="row p-0 m-0 pb-4 ">
              <div class="col-4 pr-4">
                    <b-form-group label="" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseur" label="name" v-model="selectedSupplier">
                        <span slot="no-options">Aucun fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
              </div>
              <div class="col-8">
                <b-input-group  >
                    <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque ou Groupe"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
                        ></b-form-input>                              
                    <template v-slot:append>
                        <b-button variant="success" @click="findItems()">
                        <i class="bx bx-search-alt font-size-16 align-middle"></i>
                        </b-button>
                    </template>
                    <!-- <template v-slot:prepend>
                        <b-dropdown size=""  :text="selectedSupplierName ? selectedSupplierName :'Tous les Fournisseurs'" variant="outline-success" >
                            <b-dropdown-item @click="selectedSupplier=null;findItems();selectedSupplierName =null" >Tous les Fournisseurs</b-dropdown-item>
                            <b-dropdown-item v-for="supplier in suppliersList" 
                                :key="supplier.id" 
                                :value="supplier.id"
                                @click="selectedSupplier=supplier.id; findItems(); selectedSupplierName =supplier.name "
                                >{{supplier.name}}</b-dropdown-item>
                        </b-dropdown>
                  </template> -->
                </b-input-group>
              </div>
            </div>
            <div class="row ">
                <div class ="col-12">
                    <div class="card border border-success bg-Default">
                    <div class="table-responsive mb-0">
                    <table class="table table-centered table-fixed ">
                        <thead class="thead-light">
                            <tr>
                                <th class="text-left " style="width:130px">Fournisseur </th>
                                <th class="text-left">Désignation</th>
                                <th class="text-left ">Référence </th>
                                <th class="text-left ">Marque </th>
                                <th class="text-left ">Groupe </th>
                                <th class="text-center">Image</th>
                                <th class="text-right ">Catégorie </th>
                                <th class="text-right " style="width:130px">Prix HT</th>
                                <th class="text-right ">Remise</th>
                                <th class="text-right ">Gratuités</th>
                                <th class="text-right " style="width:130px">Prix HT Négocié</th>
                                <th class="text-right ">Stock</th>
                                <th class="text-left "> Multiple</th>
                                <th class="text-right "> Visibilité</th>
                            </tr>
                        </thead>

                        <tbody>

                        <tr v-for="data in itemsList" :key="data.id" >
                            <td class="text-left font-weight-bold font-size-14 text-danger" >{{data.supplierName}}</td>
                            <td class="text-left font-weight-bold font-size-14">{{data.title}}</td>
                            <td class="text-left ">{{data.ref}}</td>
                            <td class="text-left " v-if="data.brand===null">{{data.brand}}</td>
                            <td class="text-left " v-else>{{data.brand.name}}</td>
                            <td class="text-left " v-if="data.itemGroup===null">{{data.itemGroup}}</td>
                            <td class="text-left " v-else>{{data.itemGroup.name}}</td>
                            <td class="text-center">
                                <img v-bind:src="'/api/image/get/' + data.image" @click="imageModalUrl= '/api/image/get/' + data.image;showImageModal = true; imageModalSelectedItem=data" alt height="40" width="60" style="cursor: pointer;" />
                            </td>
                            <td class="text-right " >
                                <span  class="font-size-13"
                                :class="data.category===0 ? 'badge ml-1 badge-success badge-pill' : 'badge ml-1 badge-secondary   badge-pill' ">{{data.category===0 ? 'Pharma' : 'P. Para'}}
                                </span>
                            </td>           
                            <td class="text-right font-size-14 ">{{data.price}}</td>
                            <td v-if="data.discount===null || data.discount===0" class="text-right font-weight-bold font-size-14 "></td>

                            <td v-else  class="text-right font-weight-bold font-size-14 ">{{data.discount}} %</td>

                            <td v-if="!data.gratuity || data.gratuity===0" class="text-right font-weight-bold font-size-14 "></td>
                            <td v-else class="text-center font-weight-bold font-size-14 "><span
                                href="javascript: void(0);"
                                class="badge badge-info font-size-14 m-3"
                            ><i class="fas fa-star mr-2"/>{{data.gratuity}}</span></td>
                            

                            <td class="text-right font-weight-bold text-success font-size-14">{{data.discountedPrice}}</td>

                            <td class="text-center "> 
                            <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
                            <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-info font-size-16"> </i>
                            </td>
                            <td class="text-left "><span  class="font-size-14 font-weight-bold ">{{data.multiple}} </span></td>
                            <td class="text-center "> 
                                <i :class="data.isVisible ? 'far fa-eye text-info' : 'far fa-eye-slash text-danger' " ></i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="isItemsTableBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
                    </div>
                    <span v-if="!isItemsTableBusy & !itemsList.length & endOfFindItems" class="d-flex justify-content-center m-4 text-danger" >Aucun article dans la liste</span>
                    </div>

                    </div>
                    <!-- Pagination -->
                    <div class="row pt-3 mb-sm-4">
                        <div class="col-sm-8">
                            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <!-- Fin Pagination  -->
                </div>

            </div>
          </div>
        </div>
      </div>
       <b-modal v-model="showImageModal" 
        title="L'image de l'article" 
        hide-footer 
        centered 
        title-class="text-warning"
        title-tag="h5"
        header-close-variant="danger">

       <div class="row p-2 zoom-container">
          <img v-bind:src="imageModalUrl"  alt height="100%" width="100%" />
       </div>
    </b-modal>
    </div>
  </Layout>
</template>
<style>
.mdi:before, .mdi-set {
    display: inline;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
     box-shadow: 0 0 0 30px white inset;
}

</style>
